import { createContext } from "react";
import { IAudioDispatch } from "./audio-context.types";

export const AudioDispatchContext = createContext<IAudioDispatch>(() => new Error("No provider"));
